import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { setPostLoginPath } from '../../utils/postLogin';

const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen bg-white">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-200 border-t-theme-primary mx-auto mb-4"></div>
      <p className="text-gray-600 font-medium text-sm">Loading...</p>
    </div>
  </div>
);

// adminOnly    = club admins + super admins (not plain sponsors)
// superOnly    = super admins only
const ProtectedRoute = ({ children, adminOnly = false, superOnly = false }) => {
  const { isAuthenticated, isSuperAdmin, isClubAdmin } = useAuth();
  const location = useLocation();

  if (isAuthenticated === null) return <LoadingSpinner />;
  if (!isAuthenticated) {
    // Return here after signing in (only allow-listed paths are honoured).
    setPostLoginPath(location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }
  if (superOnly && !isSuperAdmin) return <Navigate to="/dashboard" replace />;
  if (adminOnly && !isClubAdmin && !isSuperAdmin) return <Navigate to="/dashboard" replace />;

  return children;
};

export default ProtectedRoute;
